export type SearchSearch = {
  hotelIds?: string[];
  checkIn?: string;
  nights?: number;
  guests?: number;
};

const coerceStringArray = (raw: unknown): string[] | undefined => {
  if (Array.isArray(raw)) return raw.filter((v) => typeof v === 'string');
  if (typeof raw === 'string' && raw.length > 0) return raw.split(',');
  return undefined;
};

const coerceInt = (raw: unknown): number | undefined => {
  const n = Number(raw);
  return Number.isFinite(n) && n > 0 ? Math.floor(n) : undefined;
};

const ISO_DATE_RE = /^\d{4}-\d{2}-\d{2}$/;

export const validateSearchSearch = (
  input: Record<string, unknown>
): SearchSearch => ({
  hotelIds: coerceStringArray(input.hotelIds),
  checkIn:
    typeof input.checkIn === 'string' && ISO_DATE_RE.test(input.checkIn)
      ? input.checkIn
      : undefined,
  nights: coerceInt(input.nights),
  guests: coerceInt(input.guests),
});
